const generateUrl = () => {
    if (window.location.origin === "http://localhost:3000") {
        return "http://3.131.68.12:3149"
    } else {
        return window.location.origin
    }
}

export const apiURL = `http://3.131.68.12:3149/api`
export const apiGraphURL = `http://3.131.68.12:3149/api/graphql`

export const getTokenApi = () => {
    let token = JSON.parse(sessionStorage.getItem('accessToken'))
    let bearer = `Bearer ${token}`
    return bearer
}

export const statusObjOrders = {
    1: 'light-statusNew',
    2: 'light-statusPending',
    3: 'light-statusPaid',
    4: "light-statusPaymentPending",
    5: "light-statusPaymentDeclined",
    6: "light-statusCanceled",
    7: "light-statusReturned"
}

export const numFixer = Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})
